import { FC } from "react";
import { useSnackbar } from "notistack";
import {
  FormWrapper,
  FormTitle,
} from "@/components/Forms/components/MonolithFormComponents";
import { DefaultOfficeForm, OfficeFormData } from "./DefaultOfficeForm";
import { createOffice } from "@/api/offices";
import LoggingAPI from "@/api/logging";
import { usePermissions } from "@/hooks/usePermissions";
import { VariantType } from "notistack";

interface CreateOfficeFormProps {
  width?: number | string;
  onSubmit: () => void;
  onCancel: () => void;
}

const CreateOfficeForm: FC<CreateOfficeFormProps> = ({
  width,
  onSubmit,
  onCancel,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { currentUser } = usePermissions();

  const handleSubmit = async (data: OfficeFormData) => {
    try {
      await createOffice(data);
      onSubmit?.();
      enqueueSnackbar(`Office ${data?.office_name || ""} created`, {
        variant: "success" as VariantType,
      });

      LoggingAPI.createLog({
        user_id: currentUser.user_id,
        message: `Created Office: ${data?.office_name}`,
        event: "office:create",
        object_type: "office",
      });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(
        "An error occurred while creating this office. Please try again.",
        { variant: "error" as VariantType }
      );
    }
  };

  return (
    <FormWrapper width={width}>
      <FormTitle>Create Office</FormTitle>
      <DefaultOfficeForm
        onSubmit={handleSubmit}
        onCancel={onCancel}
        buttonProps={{ submitText: "Create Office" }}
      />
    </FormWrapper>
  );
};

export default CreateOfficeForm;
